module.exports = __webpack_public_path__ + "static/media/infrastructure.b50bf4b9.svg";